var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "indexbg"
  }, [_c('topbar'), _vm._v(" "), _c('emallheader', {
    ref: "c1"
  }), _vm._v(" "), _c('headernav', {
    ref: "navComp",
    attrs: {
      "activeLi": _vm.activeLi
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clear mt15"
  }), _vm._v(" "), _c('div', {
    staticClass: "w1200 bc"
  }, [_c('div', {
    staticClass: "hq-crumb-wrap"
  }, [_c('ul', [_vm._m(0), _vm._v(" "), _c('li', {
    staticClass: "item sep"
  }, [_vm._v(">")]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.getGoodList(_vm.catCode, _vm.goodsCatNameCn)
      }
    }
  }, [_vm._v(_vm._s(_vm.goodsCatNameCn))])]), _vm._v(" "), _c('li', {
    staticClass: "item sep"
  }, [_vm._v(">")]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.getGoodDetails(_vm.goodsCode)
      }
    }
  }, [_vm._v(_vm._s(_vm.goodsDetail.goodsName))])])])]), _vm._v(" "), _c('div', {
    staticClass: "db-goods-show"
  }, [_c('div', {
    staticClass: "goodspic"
  }, [_c('div', {
    staticClass: "spec-preview",
    attrs: {
      "id": "preview"
    }
  }, [_c('span', {
    staticClass: "jqzoom"
  }, [_c('img', {
    attrs: {
      "jqimg": _vm.goodsImgLarge,
      "src": _vm.goodsImgLarge,
      "width": "430px",
      "height": "430px"
    }
  })]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "spec-scroll"
  }, [_c('a', {
    staticClass: "prev",
    attrs: {
      "title": "上一张"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "next",
    attrs: {
      "title": "下一张"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "items"
  }, [_c('ul', _vm._l((_vm.goodsImgs), function(gI, index) {
    return _c('li', [_c('img', {
      attrs: {
        "alt": "",
        "bimg": gI,
        "src": gI
      },
      on: {
        "click": function($event) {
          _vm.choosePic(index)
        }
      }
    })])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "dt-m"
  }, [_c('div', {
    staticClass: "sp-title"
  }, [_c('h3', [_vm._v(" " + _vm._s(_vm.goodsName))])]), _vm._v(" "), (_vm.seckillPrice != '' && _vm.seckillPrice > 0) ? _c('div', {
    staticClass: "shop-miaosha"
  }, [_c('img', {
    staticClass: "miaosha-img",
    attrs: {
      "src": require("../../../static/images/miaosha_white.png"),
      "alt": ""
    }
  }), _vm._v("\n            \t\t\t\t秒杀\n            \t\t\t\t"), _vm._v(" "), (_vm.activityEndTime > 0) ? _c('span', {
    staticClass: "miaosha-time"
  }, [_vm._v("\n                \t\t\t\t距离结束"), _c('i', [_vm._v(_vm._s(_vm.hour))]), _vm._v(":"), _c('i', [_vm._v(_vm._s(_vm.minute))]), _vm._v(":"), _c('i', [_vm._v(_vm._s(_vm.second))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.seckillPrice == '' && _vm.nextBeginTime != '') ? _c('div', {
    staticClass: "shop-miaosha"
  }, [_c('img', {
    staticClass: "miaosha-img",
    attrs: {
      "src": require("../../../static/images/miaosha_white.png"),
      "alt": ""
    }
  }), _vm._v("\n            \t\t\t\t秒杀预告\n            \t\t\t\t"), _vm._v(" "), (_vm.nextBeginTime != '') ? _c('span', {
    staticClass: "miaosha-time"
  }, [_vm._v("\n                \t\t\t\t预计" + _vm._s(_vm.nextBeginTime.substr(0, 4)) + "年" + _vm._s(_vm.nextBeginTime.substr(4, 2)) + "月" + _vm._s(_vm.nextBeginTime.substr(6, 2)) + "日" + _vm._s(_vm.nextBeginTime.substr(8, 2)) + ":" + _vm._s(_vm.nextBeginTime.substr(10, 2)) + "开始\n                \t\t\t")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.goodsBo.productType == 'product' || _vm.goodsBo.productType == 'meterial') ? _c('h4', {
    staticClass: "goods_b",
    class: {
      "active": _vm.orderType === "spot", "disableColor": _vm.goodsBo.goodsNumber <= 10
    },
    on: {
      "click": function($event) {
        (_vm.goodsBo.goodsNumber > 10) ? _vm.changeTab('spot'): ''
      }
    }
  }, [_vm._v("现货")]) : _vm._e(), _vm._v(" "), (_vm.goodsBo.productType == 'product' || _vm.goodsBo.productType == 'sample') ? _c('h4', {
    staticClass: "goods_b",
    class: {
      "active": _vm.orderType === "custom"
    },
    on: {
      "click": function($event) {
        _vm.changeTab('custom')
      }
    }
  }, [_vm._v("订购")]) : _vm._e(), _vm._v(" "), (_vm.goodsBo.productType == 'product' || _vm.goodsBo.productType == 'sample') ? _c('h4', {
    staticClass: "goods_b",
    class: {
      "active": _vm.orderType === "proof"
    },
    on: {
      "click": function($event) {
        _vm.changeTab('proof')
      }
    }
  }, [_vm._v("打样")]) : _vm._e(), _vm._v(" "), (_vm.goodsBo.productType == 'meterial') ? _c('h4', {
    staticClass: "goods_b",
    class: {
      "active": _vm.orderType === "purchase"
    },
    on: {
      "click": function($event) {
        _vm.changeTab('purchase')
      }
    }
  }, [_vm._v("加工订购")]) : _vm._e(), _vm._v(" "), (_vm.orderType != 'purchase') ? _c('div', {
    staticClass: "sp-price"
  }, [(_vm.priceAreaJson != '') ? _c('div', {
    staticStyle: {
      "float": "left",
      "width": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [(_vm.orderType == 'spot') ? _c('dt', {
    staticClass: "item-3",
    staticStyle: {
      "width": "70px"
    }
  }, [_vm._v("价格 ")]) : _vm._e(), _vm._v(" "), (_vm.orderType != 'spot') ? _c('dt', {
    staticClass: "item-3",
    staticStyle: {
      "width": "70px"
    }
  }, [_vm._v("参考价格 ")]) : _vm._e(), _vm._v(" "), _c('dt', {
    staticClass: "item-3",
    staticStyle: {
      "width": "70px"
    }
  }, [_vm._v("数量 ")])]), _vm._v(" "), _vm._l((JSON.parse(_vm.priceAreaJson).orderPrice), function(orderPrice, index) {
    return (Array.isArray(JSON.parse(_vm.priceAreaJson).orderPrice)) ? _c('li', {
      staticStyle: {
        "float": "left"
      }
    }, [(index < (JSON.parse(_vm.priceAreaJson).orderPrice.length - 1)) ? _c('span', {
      staticClass: "co2"
    }, [_vm._v("￥"), _c('span', {
      staticClass: "f30 co2",
      class: {
        fb: (_vm.payNum >= parseInt(JSON.parse(_vm.priceAreaJson).orderNum[index]) && _vm.payNum < parseInt(JSON.parse(_vm.priceAreaJson).orderNum[index + 1]))
      }
    }, [_vm._v(_vm._s(orderPrice == 0 ? '暂无价格' : orderPrice))])]) : _vm._e(), _vm._v(" "), (index == (JSON.parse(_vm.priceAreaJson).orderPrice.length - 1)) ? _c('span', {
      staticClass: "co2"
    }, [_vm._v("￥"), _c('span', {
      staticClass: "f30 co2",
      class: {
        fb: _vm.payNum >= parseInt(JSON.parse(_vm.priceAreaJson).orderNum[index])
      }
    }, [_vm._v(_vm._s(orderPrice == 0 ? '暂无价格' : orderPrice))])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (index < (JSON.parse(_vm.priceAreaJson).orderPrice.length - 1)) ? _c('div', [_vm._v(_vm._s(JSON.parse(_vm.priceAreaJson).orderNum[index]) + "-" + _vm._s(JSON.parse(_vm.priceAreaJson).orderNum[index + 1] - 1) + "件")]) : _vm._e(), _vm._v(" "), (index == (JSON.parse(_vm.priceAreaJson).orderPrice.length - 1)) ? _c('div', [_vm._v("≥" + _vm._s(JSON.parse(_vm.priceAreaJson).orderNum[index]) + "件")]) : _vm._e()]) : _vm._e()
  }), _vm._v(" "), (!Array.isArray(JSON.parse(_vm.priceAreaJson).orderPrice)) ? _c('li', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('span', {
    staticClass: "co2"
  }, [_vm._v("￥"), _c('span', {
    staticClass: "f30 co2 fb"
  }, [_vm._v(_vm._s(JSON.parse(_vm.priceAreaJson).orderPrice == 'null' || JSON.parse(_vm.priceAreaJson).orderPrice == 0 ? '暂无价格' : JSON.parse(_vm.priceAreaJson).orderPrice))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_vm._v("≥" + _vm._s(JSON.parse(_vm.priceAreaJson).orderNum) + "件")])]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.orderType != 'spot' && _vm.priceAreaJson != '') ? _c('div', {
    staticClass: "co3"
  }, [_vm._v("需要后台业务员联系报价，才可正式下单.")]) : _vm._e(), _vm._v(" "), (_vm.priceAreaJson == '' && _vm.goodsPrice1 == 0) ? _c('div', {
    staticClass: "item-2 co2"
  }, [(_vm.isSpike == 'y') ? _c('span', {
    staticStyle: {
      "color": "#938a8c"
    }
  }, [_vm._v("秒杀价:")]) : _vm._e(), _vm._v(" "), ((_vm.brokerDiscountPersent == 0 || _vm.brokerDiscountPersent == 100) && _vm.seckillPrice == 0) ? _c('span', [_c('span', {
    staticClass: "co2"
  }, [(_vm.orderType != 'spot') ? _c('span', [_vm._v("参考价格：")]) : _vm._e()]), _vm._v("￥"), _c('span', {
    staticClass: "f30 fb co2"
  }, [_vm._v(_vm._s(_vm.goodsPrice == 0 ? '暂无价格' : _vm.goodsPrice))])]) : _vm._e(), _vm._v(" "), ((_vm.brokerDiscountPersent != 0 && _vm.brokerDiscountPersent != 100) || _vm.seckillPrice > 0) ? _c('span') : _vm._e(), _vm._v(" "), (_vm.brokerDiscountPersent != 0 && _vm.brokerDiscountPersent != 100 && _vm.seckillPrice == 0) ? _c('span', [_c('span', {
    staticClass: "co2"
  }, [_vm._v("￥"), _c('span', {
    staticClass: "f30 fb co2"
  }, [_vm._v(_vm._s(_vm.brokerPrice))])])]) : _vm._e(), _vm._v(" "), (_vm.seckillPrice > 0) ? _c('span', {
    staticClass: "f30 fb"
  }, [_vm._v("秒杀价：￥" + _vm._s((_vm.seckillPrice / 100).toFixed(2)))]) : _vm._e(), _vm._v(" "), (_vm.marketPrice > 0) ? _c('span', {
    staticClass: "zhe"
  }, [_vm._v(_vm._s(_vm.discount) + "折")]) : _vm._e(), _vm._v(" "), (_vm.goodsBo.rewardPointRate > 0 && (Math.floor(_vm.maxPrice * _vm.goodsBo.rewardPointRate / 100) > 0 || _vm.chooseGoodsPrice > 0) && (_vm.chooseGoodsPrice != '' ? Math.floor(_vm.chooseGoodsPrice * _vm.goodsBo.rewardPointRate / 100) : (Math.floor(_vm.minPrice * _vm.goodsBo.rewardPointRate / 100) + '-' + Math.floor(_vm.maxPrice * _vm.goodsBo.rewardPointRate / 100))) != 0) ? _c('span', {
    staticClass: "co_r mr10 f15",
    staticStyle: {
      "font-size": "0.6rem !important",
      "border": "1px red solid",
      "border-radius": "3px",
      "padding": "0 0.2rem 0 0.2rem"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t赠" + _vm._s(_vm.chooseGoodsPrice != '' ? Math.floor(_vm.chooseGoodsPrice * _vm.goodsBo.rewardPointRate / 100 / 100) : (Math.floor(_vm.minPrice * _vm.goodsBo.rewardPointRate / 100) + "-" + Math.floor(_vm.maxPrice * _vm.goodsBo.rewardPointRate / 100))) + "积分\n\t\t\t\t\t\t\t\t")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.priceAreaJson == '' && _vm.goodsPrice1 != 0) ? _c('div', {
    staticClass: "item-2 co2"
  }, [_c('span', {
    staticClass: "f14"
  }), _vm._v(" "), _c('span', {
    staticClass: "f30 fb"
  }, [_vm._v(_vm._s(_vm.goodsPrice1) + "\n\t\t\t\t\t\t\t\t\t"), (_vm.pointType == 'point') ? _c('span', [_vm._v("积分")]) : (_vm.pointType == 'special') ? _c('span', [_vm._v("专用积分")]) : (_vm.pointType == 'red') ? _c('span', [_vm._v("红积分")]) : (_vm.pointType == 'blue') ? _c('span', [_vm._v("蓝积分")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.orderType != 'spot' && _vm.priceAreaJson == '') ? _c('div', {
    staticClass: "co3"
  }, [_vm._v("需要后台业务员联系报价，才可正式下单")]) : _vm._e(), _vm._v(" "), (_vm.marketPrice > 0) ? _c('div', {
    staticClass: "item-3"
  }, [_vm._v("市场价："), _c('span', {
    staticClass: "cost-price"
  }, [_vm._v("￥" + _vm._s(_vm.marketPrice.toFixed(2)))]), _vm._v("（为您节省￥" + _vm._s(_vm.breaks) + " ）")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('dl', {
    staticClass: "sp-meta",
    class: {
      "top40": _vm.orderType === "purchase", "top140": _vm.orderType != "purchase"
    }
  }, [_vm._l((_vm.skuList), function(skuAttr, index_n) {
    return _c('div', [(skuAttr.skuName != null && skuAttr.skuName != '') ? _c('dt', [_vm._v(_vm._s(skuAttr.skuName) + "：")]) : _vm._e(), _vm._v(" "), (skuAttr.skuValue != null && skuAttr.skuValue != '') ? _c('dd', _vm._l((skuAttr.skuValue.split(',')), function(specItem, index) {
      return (specItem != null && specItem != '' && _vm.existsSku(specItem, index_n)) ? _c('a', {
        staticClass: "td-txt",
        class: {
          selected: specItem == _vm.skuList[index_n].skuChoosed
        },
        on: {
          "click": function($event) {
            specItem != _vm.skuList[index_n].skuChoosed && _vm.chooseSpec(specItem, index_n)
          }
        }
      }, [_vm._v(_vm._s(specItem))]) : _vm._e()
    })) : _vm._e()])
  }), _vm._v(" "), (_vm.orderType == 'purchase') ? _c('div', [(_vm.goodsDetail.orderQuantity != undefined && _vm.goodsDetail.orderQuantity > 0) ? _c('div', [_c('dt', [_vm._v("起订：")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.goodsDetail.orderQuantity) + "件")])]) : _vm._e(), _vm._v(" "), _c('div', [_c('dt', [_vm._v("原始价格：")]), _vm._v(" "), (_vm.chooseGoodsPrice != '') ? _c('dd', {
    staticStyle: {
      "color": "#EF920D"
    }
  }, [_vm._v(_vm._s(_vm.goodsPrice) + "元")]) : _vm._e(), _vm._v(" "), (_vm.minPrice > 0 && _vm.chooseGoodsPrice == '') ? _c('dd', {
    staticStyle: {
      "color": "#EF920D"
    }
  }, [_vm._v(_vm._s(_vm.minPrice) + "元"), (_vm.maxPrice > _vm.minPrice) ? _c('span', [_vm._v("  - " + _vm._s(_vm.maxPrice) + "元")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', [_c('dt', [_vm._v("生产数量：")]), _vm._v(" "), _c('dd', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.produceNum),
      expression: "produceNum"
    }],
    staticClass: "inpt",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "id": "produceNum",
      "type": "number",
      "onkeypress": "return(/[\\d]/.test(String.fromCharCode(event.keyCode)))",
      "min": "1"
    },
    domProps: {
      "value": (_vm.produceNum)
    },
    on: {
      "keyup": function($event) {
        _vm.setProduceNum()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.produceNum = $event.target.value
      }
    }
  }), _vm._v("  个")])]), _vm._v(" "), _c('div', [_c('dt', [_vm._v("验货方式")]), _vm._v(" "), _c('dd', _vm._l((_vm.inspectionTypes), function(ins, index) {
    return (ins.dictValue != '') ? _c('a', {
      staticClass: "td-txt",
      class: {
        selected: _vm.inspectionType == ins.dictValue
      },
      on: {
        "click": function($event) {
          _vm.chooseInspection(ins.dictValue)
        }
      }
    }, [_vm._v(_vm._s(ins.dictText))]) : _vm._e()
  }))])]) : _vm._e(), _vm._v(" "), (_vm.isLogin && (_vm.expressMode == 'weight' || _vm.expressMode == 'counter')) ? _c('dt', [_vm._v("配送至：")]) : _vm._e(), _vm._v(" "), (_vm.isLogin && (_vm.expressMode == 'weight' || _vm.expressMode == 'counter')) ? _c('dd', [_c('span', [_vm._v("配送至：")]), _vm._v(" "), _c('select', {
    staticClass: "city_select_css",
    attrs: {
      "id": "expressChage"
    },
    on: {
      "input": function($event) {
        _vm.expressChage()
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "北京市"
    }
  }, [_vm._v("北京")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "天津市"
    }
  }, [_vm._v("天津")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "河北省"
    }
  }, [_vm._v("河北")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "山西省"
    }
  }, [_vm._v("山西")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "内蒙古自治区"
    }
  }, [_vm._v("内蒙古")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "辽宁省"
    }
  }, [_vm._v("辽宁")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "吉林省"
    }
  }, [_vm._v("吉林")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "黑龙江省"
    }
  }, [_vm._v("黑龙江")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "上海市"
    }
  }, [_vm._v("上海")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "江苏省"
    }
  }, [_vm._v("江苏")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "浙江省"
    }
  }, [_vm._v("浙江")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "安徽省"
    }
  }, [_vm._v("安徽")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "福建省"
    }
  }, [_vm._v("福建")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "江西省"
    }
  }, [_vm._v("江西")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "山东省"
    }
  }, [_vm._v("山东")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "河南省"
    }
  }, [_vm._v("河南")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "湖北省"
    }
  }, [_vm._v("湖北")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "湖南省"
    }
  }, [_vm._v("湖南")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "广东省"
    }
  }, [_vm._v("广东")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "广西壮族自治区"
    }
  }, [_vm._v("广西")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "海南省"
    }
  }, [_vm._v("海南")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "重庆省"
    }
  }, [_vm._v("重庆")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "四川省"
    }
  }, [_vm._v("四川")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "贵州省"
    }
  }, [_vm._v("贵州")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "云南省"
    }
  }, [_vm._v("云南")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "西藏自治区"
    }
  }, [_vm._v("西藏")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "陕西省"
    }
  }, [_vm._v("陕西")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "甘肃省"
    }
  }, [_vm._v("甘肃")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "青海省"
    }
  }, [_vm._v("青海")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "宁夏回族自治区"
    }
  }, [_vm._v("宁夏")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "新疆维吾尔族自治区"
    }
  }, [_vm._v("新疆")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "香港特别行政区"
    }
  }, [_vm._v("香港")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "澳门特别行政区"
    }
  }, [_vm._v("澳门")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "台湾省"
    }
  }, [_vm._v("台湾")])])]) : _vm._e(), _vm._v(" "), _c('table', [(_vm.orderType == 'custom') ? _c('tr', [_vm._m(2), _c('td', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customize_desc),
      expression: "customize_desc"
    }],
    attrs: {
      "rows": "5",
      "cols": "70"
    },
    domProps: {
      "value": (_vm.customize_desc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.customize_desc = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.orderType == 'proof') ? _c('tr', [_vm._m(3), _c('td', [_c('table', {
    attrs: {
      "width": "80%"
    }
  }, [_vm._m(4), _vm._v(" "), _vm._l((_vm.partChangeList), function(partChange, k) {
    return _c('tr', [_c('td', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (partChange.name),
        expression: "partChange.name"
      }],
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          partChange.name = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, _vm._l((_vm.partTypes), function(ptType, index) {
      return (_vm.isPartShow(k, index)) ? _c('option', [_vm._v(_vm._s(ptType.dictValue))]) : _vm._e()
    }))]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (partChange.value),
        expression: "partChange.value"
      }],
      staticClass: "inpt",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (partChange.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          partChange.value = $event.target.value
        }
      }
    }), _vm._v(" "), (k == 0) ? _c('a', {
      staticClass: "plus",
      on: {
        "click": function($event) {
          _vm.addPart()
        }
      }
    }, [_vm._v("+")]) : _vm._e(), _vm._v(" "), (k != 0) ? _c('a', {
      staticClass: "minus",
      on: {
        "click": function($event) {
          _vm.delPart(k)
        }
      }
    }, [_vm._v("-")]) : _vm._e()])])
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.orderType == 'proof' || _vm.orderType == 'purchase') ? _c('tr', [_c('td', [(_vm.orderType == 'proof') ? _c('dt', [_vm._v("打样备注")]) : _vm._e(), (_vm.orderType == 'purchase') ? _c('dt', [_vm._v("加工说明")]) : _vm._e()]), _c('td', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.remark),
      expression: "remark"
    }],
    attrs: {
      "rows": "5",
      "cols": "70"
    },
    domProps: {
      "value": (_vm.remark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.remark = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.orderType == 'proof' || _vm.orderType == 'purchase') ? _c('tr', [_vm._m(5), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "td-txt",
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.change_input()
      }
    }
  }, [_vm._v("选择")]), _vm._v(" "), _c('form', {
    attrs: {
      "id": "addTextForm"
    },
    on: {
      "change": function($event) {
        _vm.setImg($event)
      }
    }
  }, [_c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "0",
      "type": "file",
      "name": "style_picture"
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "1",
      "type": "file",
      "name": "style_picture"
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "2",
      "type": "file",
      "name": "style_picture"
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "3",
      "type": "file",
      "name": "style_picture"
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "4",
      "type": "file",
      "name": "style_picture"
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "img-wrapper"
    },
    on: {
      "click": function($event) {
        _vm.deleteImg($event)
      }
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "48%",
      "display": "none",
      "max-height": "200px"
    },
    attrs: {
      "src": "",
      "id": "img_0"
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "max-width": "48%",
      "display": "none",
      "max-height": "200px"
    },
    attrs: {
      "src": "",
      "id": "img_1"
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "max-width": "48%",
      "display": "none",
      "max-height": "200px"
    },
    attrs: {
      "src": "",
      "id": "img_2"
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "max-width": "48%",
      "display": "none",
      "max-height": "200px"
    },
    attrs: {
      "src": "",
      "id": "img_3"
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "max-width": "48%",
      "display": "none",
      "max-height": "200px"
    },
    attrs: {
      "src": "",
      "id": "img_4"
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [((_vm.orderType == 'spot') && _vm.goodsDetail.printService > 0) ? _c('dt', [_vm._v("印刷服务:")]) : _vm._e()]), _vm._v(" "), ((_vm.orderType == 'spot') && _vm.goodsDetail.printService > 0) ? _c('td', [_c('a', {
    staticClass: "td-txt",
    class: {
      selected: _vm.printService != ''
    },
    on: {
      "click": function($event) {
        _vm.choosePrint(_vm.goodsDetail.printService)
      }
    }
  }, [_vm._v("印刷")]), _vm._v(_vm._s(_vm.goodsDetail.printService / 100) + "元/件\n                 \t\t\t\n                 \t\t")]) : _vm._e()]), _vm._v(" "), (_vm.orderType == 'purchase' || _vm.orderType == 'custom') ? _c('tr', [_c('td', [(_vm.goodsDetail.laserService > 0) ? _c('dt', [_vm._v("激光服务:")]) : _vm._e()]), _vm._v(" "), (_vm.goodsDetail.laserService > 0) ? _c('td', [_c('a', {
    staticClass: "td-txt",
    class: {
      selected: _vm.laserService != ''
    },
    on: {
      "click": function($event) {
        _vm.chooseLaster(_vm.goodsDetail.laserService)
      }
    }
  }, [_vm._v("激光")]), _vm._v(_vm._s(_vm.goodsDetail.laserService / 100) + "元/件\n\t\t\t\t\t\t")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.orderType == 'purchase' || _vm.orderType == 'custom') ? _c('tr', [_c('td', [(_vm.goodsDetail.printingService > 0) ? _c('dt', [_vm._v("印花服务:")]) : _vm._e()]), _vm._v(" "), (_vm.goodsDetail.printingService > 0) ? _c('td', [_c('a', {
    staticClass: "td-txt",
    class: {
      selected: _vm.printingService != ''
    },
    on: {
      "click": function($event) {
        _vm.choosePrinting(_vm.goodsDetail.printingService)
      }
    }
  }, [_vm._v("印花")]), _vm._v(_vm._s(_vm.goodsDetail.printingService / 100) + "元/件\n\t\t\t\t\t\t")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.orderType == 'purchase' || _vm.orderType == 'custom') ? _c('tr', [_c('td', [(_vm.goodsDetail.rebrandingService > 0) ? _c('dt', [_vm._v("换标服务:")]) : _vm._e()]), _vm._v(" "), (_vm.goodsDetail.rebrandingService > 0) ? _c('td', [_c('a', {
    staticClass: "td-txt",
    class: {
      selected: _vm.rebrandingService != ''
    },
    on: {
      "click": function($event) {
        _vm.chooseRebranding(_vm.goodsDetail.rebrandingService)
      }
    }
  }, [_vm._v("换标")]), _vm._v(_vm._s(_vm.goodsDetail.rebrandingService / 100) + "元/件\n\t\t\t\t\t\t")]) : _vm._e()]) : _vm._e(), _vm._v(" "), ((_vm.orderType == 'spot' || _vm.orderType == 'custom') && _vm.goodsDetail.qualityService != undefined && _vm.goodsDetail.qualityService != '') ? _c('tr', [_vm._m(6), _vm._v(" "), _c('td', _vm._l((_vm.qualitys), function(qua, index) {
    return (qua.dictValue == _vm.goodsDetail.qualityService) ? _c('span', [_vm._v(_vm._s(qua.dictText))]) : _vm._e()
  }))]) : _vm._e(), _vm._v(" "), ((_vm.orderType == 'spot' && _vm.goodsDetail.printService > 0) || _vm.orderType == 'custom' || _vm.orderType == 'proof') ? _c('tr', [_vm._m(7), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "td-txt",
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.change_File()
      }
    }
  }, [_vm._v("选择")]), _vm._v(" "), _c('form', {
    attrs: {
      "id": "addFileForm"
    },
    on: {
      "change": function($event) {
        _vm.setFile($event)
      }
    }
  }, [_c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "10",
      "type": "file",
      "name": "attachment"
    },
    on: {
      "change": function($event) {
        _vm.setFileName($event)
      }
    }
  }), _c('a', {
    staticClass: "minus",
    staticStyle: {
      "font-size": "20px",
      "display": "none"
    },
    attrs: {
      "id": "a_10"
    },
    on: {
      "click": function($event) {
        _vm.deleteFile($event)
      }
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "11",
      "type": "file",
      "name": "attachment"
    },
    on: {
      "change": function($event) {
        _vm.setFileName($event)
      }
    }
  }), _c('a', {
    staticClass: "minus",
    staticStyle: {
      "font-size": "20px",
      "display": "none"
    },
    attrs: {
      "id": "a_11"
    },
    on: {
      "click": function($event) {
        _vm.deleteFile($event)
      }
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "12",
      "type": "file",
      "name": "attachment"
    },
    on: {
      "change": function($event) {
        _vm.setFileName($event)
      }
    }
  }), _c('a', {
    staticClass: "minus",
    staticStyle: {
      "font-size": "20px",
      "display": "none"
    },
    attrs: {
      "id": "a_12"
    },
    on: {
      "click": function($event) {
        _vm.deleteFile($event)
      }
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "13",
      "type": "file",
      "name": "attachment"
    },
    on: {
      "change": function($event) {
        _vm.setFileName($event)
      }
    }
  }), _c('a', {
    staticClass: "minus",
    staticStyle: {
      "font-size": "20px",
      "display": "none"
    },
    attrs: {
      "id": "a_13"
    },
    on: {
      "click": function($event) {
        _vm.deleteFile($event)
      }
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "14",
      "type": "file",
      "name": "attachment"
    },
    on: {
      "change": function($event) {
        _vm.setFileName($event)
      }
    }
  }), _c('a', {
    staticClass: "minus",
    staticStyle: {
      "font-size": "20px",
      "display": "none"
    },
    attrs: {
      "id": "a_14"
    },
    on: {
      "click": function($event) {
        _vm.deleteFile($event)
      }
    }
  }, [_vm._v("-")])])])]) : _vm._e()]), _vm._v(" "), (_vm.orderType == 'purchase' || _vm.orderType == 'proof') ? _c('div', [_c('dt', [_vm._v("品质等级")]), _vm._v(" "), _c('dd', [_vm._l((_vm.qualitys), function(qua, index) {
    return (qua.dictValue != '') ? _c('a', {
      staticClass: "td-txt",
      class: {
        selected: _vm.quality == qua.dictValue
      },
      on: {
        "click": function($event) {
          _vm.chooseQuality(qua.dictValue)
        }
      }
    }, [_vm._v(_vm._s(qua.dictText))]) : _vm._e()
  }), _vm._v(" "), _c('a', {
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "href": "http://www.baomate.com/Baike/492.htm",
      "target": "_blank"
    }
  }, [_vm._v("质量标准及工艺要求")])], 2)]) : _vm._e(), _vm._v(" "), (_vm.orderType == 'spot' || _vm.orderType == 'custom' || _vm.orderType == 'proof') ? _c('dt', [_vm._v("数量：")]) : _vm._e(), _vm._v(" "), (_vm.orderType == 'spot' || _vm.orderType == 'custom' || _vm.orderType == 'proof') ? _c('dd', [_c('div', {
    staticClass: "hq-amount"
  }, [_c('span', {
    staticClass: "fl"
  }, [_c('a', {
    staticClass: "hq-amount-increase",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.subPayNum()
      }
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payNum),
      expression: "payNum"
    }],
    staticClass: "hq-amount-input",
    attrs: {
      "id": "payNum",
      "onkeypress": "return(/[\\d]/.test(String.fromCharCode(event.keyCode)))",
      "type": "number",
      "min": "1",
      "max": _vm.goodsNumber
    },
    domProps: {
      "value": (_vm.payNum)
    },
    on: {
      "keyup": function($event) {
        _vm.setPayNum()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.payNum = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "hq-amount-decrease",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.addPayNum()
      }
    }
  }, [_vm._v("+")])]), _vm._v(" "), (_vm.orderType === 'spot') ? _c('span', {
    staticClass: "fl ml10"
  }, [_vm._v("库存" + _vm._s(_vm.goodsNumber) + "件 ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.goodsDetail.weight) ? _c('dt', [_vm._v("重量：")]) : _vm._e(), _vm._v(" "), (_vm.goodsDetail.weight) ? _c('dd', [_c('div', {
    staticClass: "hq-amount"
  }, [_c('span', {
    staticClass: "fl "
  }, [_vm._v(_vm._s(_vm.goodsDetail.weight))])])]) : _vm._e(), _vm._v(" "), _c('table', [(_vm.orderType == 'custom' || _vm.orderType == 'proof') ? _c('tr', [_vm._m(8), _vm._v(" "), _c('td', [_c('datepicker', {
    attrs: {
      "name": "begin_delivery_time",
      "type": "date",
      "readonly": true,
      "disabled-date": _vm.disabledDate
    },
    model: {
      value: (_vm.begin_delivery_time),
      callback: function($$v) {
        _vm.begin_delivery_time = $$v
      },
      expression: "begin_delivery_time"
    }
  })], 1)]) : _vm._e()])], 2), _vm._v(" "), (_vm.goodsBo.isDelete == 'Y') ? _c('div', {
    staticClass: "sp-action"
  }, [(_vm.orderType == 'proof') ? _c('a', {
    staticClass: "delisting-bccolor"
  }, [_vm._v("商品已过期")]) : _vm._e(), _vm._v(" "), (_vm.orderType == 'custom') ? _c('a', {
    staticClass: "delisting-bccolor"
  }, [_vm._v("商品已过期")]) : _vm._e(), _vm._v(" "), (_vm.orderType == 'spot') ? _c('a', {
    staticClass: "delisting-bccolor"
  }, [_vm._v("商品已过期")]) : _vm._e(), _vm._v(" "), (_vm.orderType == 'purchase') ? _c('a', {
    staticClass: "delisting-bccolor"
  }, [_vm._v("商品已过期")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.goodsBo.isDelete != 'Y') ? _c('div', {
    staticClass: "sp-action"
  }, [(_vm.orderType == 'proof') ? _c('span', [(_vm.vailUserFlag == true && _vm.userIsLogin == true) ? _c('a', {
    staticClass: "sp-link-buy",
    on: {
      "click": function($event) {
        _vm.customizeApply('proof')
      }
    }
  }, [_vm._v("打样申请")]) : _vm._e(), _vm._v(" "), (_vm.vailUserFlag == false && _vm.userIsLogin == true) ? _c('a', {
    staticClass: "sp-link-buy",
    on: {
      "click": function($event) {
        _vm.toEditUserInfo()
      }
    }
  }, [_vm._v("请完善信息")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.orderType == 'custom') ? _c('span', [(_vm.vailUserFlag == true && _vm.userIsLogin == true) ? _c('a', {
    staticClass: "sp-link-buy",
    on: {
      "click": function($event) {
        _vm.customizeApply('subscribe')
      }
    }
  }, [_vm._v("订购申请")]) : _vm._e(), _vm._v(" "), (_vm.vailUserFlag == false && _vm.userIsLogin == true) ? _c('a', {
    staticClass: "sp-link-buy",
    on: {
      "click": function($event) {
        _vm.toEditUserInfo()
      }
    }
  }, [_vm._v("请完善信息")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.userIsLogin == true && _vm.orderType == 'spot') ? _c('a', {
    class: {
      dactive: _vm.goodsNumber === 0, 'delisting-bccolor': _vm.goodsBo.shopGoodsStatus === 'delisting', 'sp-link-buy': _vm.goodsBo.shopGoodsStatus === 'listing'
    },
    on: {
      "click": function($event) {
        !_vm.isPreview && (_vm.goodsNumber > 0) && _vm.goodsBo.shopGoodsStatus == 'listing' && _vm.payOrder()
      }
    }
  }, [_vm._v(_vm._s(_vm.goodsBo.shopGoodsStatus == 'delisting' ? '已下架' : '立即下单'))]) : _vm._e(), _vm._v(" "), (_vm.userIsLogin == true && _vm.orderType == 'purchase') ? _c('a', {
    class: {
      'delisting-bccolor': _vm.goodsBo.shopGoodsStatus === 'delisting', 'sp-link-buy': _vm.goodsBo.shopGoodsStatus === 'listing'
    },
    on: {
      "click": function($event) {
        _vm.goodsBo.shopGoodsStatus == 'listing' && _vm.payOrder()
      }
    }
  }, [_vm._v(_vm._s(_vm.goodsBo.shopGoodsStatus == 'delisting' ? '已下架' : '采购下单'))]) : _vm._e(), _vm._v(" "), (_vm.userIsLogin == true && _vm.orderType == 'spot' && _vm.canAddToShoppingCart && _vm.distributeAccount == '' && _vm.goodsBo.shopGoodsStatus === 'listing' && _vm.seckillPrice == 0) ? _c('a', {
    staticClass: "sp-link-add",
    class: {
      dactive: _vm.goodsNumber === 0
    },
    on: {
      "click": function($event) {
        !_vm.isPreview && (_vm.goodsNumber > 0) && _vm.addToShoppingCart()
      }
    }
  }, [_c('i', {
    staticClass: "ico-cart-w"
  }), _vm._v("加入购物车")]) : _vm._e(), _vm._v(" "), (_vm.userIsLogin == false) ? _c('a', {
    staticClass: "sp-link-add",
    on: {
      "click": function($event) {
        _vm.toUserLogin()
      }
    }
  }, [_vm._v("请登录")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sp-other"
  }, [(_vm.goodsBo.isDelete != 'Y') ? _c('span', {
    staticClass: "mr40"
  }, [_c('i', {
    staticClass: "ico-sp-sc"
  }), _c('a', {
    staticClass: "co1",
    on: {
      "click": function($event) {
        !_vm.isPreview && _vm.addOrDeleteFavoriteGoods()
      }
    }
  }, [_vm._v(_vm._s(_vm.isExistFavoriteGoods == 0 ? '收藏' : '已收藏'))])]) : _vm._e(), _vm._v(" "), (_vm.goodsBo.seven_day_return == 'Y') ? _c('span', {
    staticClass: "co1"
  }, [_c('i', {
    staticClass: "ico-sp-tk"
  }), _vm._v("支持7天无理由退货服务")]) : _vm._e()]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "post_btmshare"
  }, [_c('span', {
    staticClass: "post_topshare_title"
  }, [_vm._v("分享到：")]), _vm._v(" "), _c('ul', {
    staticClass: "post_share"
  }, [_c('li', {
    staticClass: "share_weixin js_weixin",
    attrs: {
      "data-type": "btm"
    },
    on: {
      "click": function($event) {
        _vm.easyShare('weixin')
      }
    }
  }, [_vm._m(9)]), _vm._v(" "), _c('li', {
    staticClass: "share_qzone js_share",
    attrs: {
      "data-type": "qzone"
    },
    on: {
      "click": function($event) {
        _vm.easyShare('qzone')
      }
    }
  }, [_vm._m(10)]), _vm._v(" "), _c('li', {
    staticClass: "share_weibo js_share",
    attrs: {
      "data-type": "weibo"
    },
    on: {
      "click": function($event) {
        _vm.easyShare('weibo')
      }
    }
  }, [_vm._m(11)]), _vm._v(" "), _c('li', {
    staticClass: "share_pic js_share",
    attrs: {
      "data-type": "btm"
    },
    on: {
      "click": function($event) {
        _vm.easyShare('picqrcode')
      }
    }
  }, [_vm._m(12)])]), _vm._v(" "), _c('div', {
    staticClass: "js_qrcode_wrap",
    attrs: {
      "id": "js_qrcode_top"
    }
  }, [_c('div', {
    staticClass: "js_qrcode_arr"
  }), _vm._v(" "), _c('a', {
    staticClass: "js_qrcode_close",
    attrs: {
      "target": "_self",
      "data-type": "top",
      "title": "关闭"
    },
    on: {
      "click": _vm.closeqrcode
    }
  }), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('p', [_vm._v("用微信扫码二维码")]), _vm._v(" "), _c('p', [_vm._v("分享至好友和朋友圈")])]), _vm._v(" "), _c('div', {
    staticClass: "js_pic_qrcode_wrap",
    attrs: {
      "id": "js_picqrcode_top"
    }
  }, [_c('div', {
    staticClass: "js_qrcode_arr"
  }), _vm._v(" "), _c('a', {
    staticClass: "js_qrcode_close",
    attrs: {
      "target": "_self",
      "data-type": "top",
      "title": "关闭"
    },
    on: {
      "click": _vm.closepicqrcode
    }
  }), _vm._v(" "), _vm._m(14)])])])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('div', {
    staticClass: "sp-side-wrap mt20"
  }, [_c('div', {
    staticClass: "hd"
  }, [_c('a', {
    staticClass: "refresh fr",
    on: {
      "click": function($event) {
        !_vm.isPreview && _vm.refreshGoods()
      }
    }
  }), _vm._v(" "), _c('h3', [_vm._v("猜你喜欢")])]), _vm._v(" "), _c('ul', _vm._l((_vm.recommendGoodsList), function(goodBo) {
    return _c('li', [_c('a', {
      staticClass: "fl pic",
      on: {
        "click": function($event) {
          _vm.goDetail(goodBo.goodsCode)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": goodBo.imgMiddle,
        "width": "106",
        "height": "106"
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "title"
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.goDetail(goodBo.goodsCode)
        }
      }
    }, [_vm._v(_vm._s(goodBo.goodsName))])]), _vm._v(" "), _c('p', {
      staticClass: "price co2"
    }, [_vm._v("￥" + _vm._s((goodBo.unitPrice / 100).toFixed(2)))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "sp-dt-tab"
  }, [_vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "bd"
  }, [_c('ul', {
    staticClass: "details-sp-cs"
  }, [_c('li', {
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._v("商品名称：" + _vm._s(_vm.goodsName))]), _vm._v(" "), (_vm.goodsDetail.brandName != null && _vm.goodsDetail.brandName != '') ? _c('li', [_vm._v("品牌： " + _vm._s(_vm.goodsDetail.brandName))]) : _vm._e(), _vm._v(" "), _c('li', [_vm._v("商品编码：" + _vm._s(_vm.goodsCode))])]), _vm._v(" "), _vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [(_vm.goodsDetail.goodsVideo) ? _c('div', {
    staticStyle: {
      "height": "20rem"
    }
  }, [_c('video', {
    staticStyle: {
      "height": "20rem",
      "margin-left": "5.5rem"
    },
    attrs: {
      "controls": "controls",
      "width": "80%"
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.imgPath + _vm.goodsDetail.goodsVideo
    }
  }), _vm._v("\n\t\t\t\t\t  Your browser does not support the video tag.\n\t\t\t\t\t")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "img-list",
    domProps: {
      "innerHTML": _vm._s(_vm.goodsDesc)
    }
  }, [_vm._v("\n                \t\t" + _vm._s(_vm.goodsDesc) + "\n              \t")])])]), _vm._v(" "), _c('div', {
    staticClass: "bd none"
  }, [_c('h4', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "ico-l"
  }), _vm._v("商品评价\n       \t  \t"), (_vm.goodRate != null) ? _c('div', {
    staticClass: "haopin"
  }, [_vm._v("好评率"), _c('span', [_c('strong', [_vm._v(_vm._s(_vm.goodRate))]), _vm._v("%")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, _vm._l((_vm.creditList), function(credit, creditIdx) {
    return _c('div', {
      staticClass: "details-sp-pinjia"
    }, [_c('div', {
      staticClass: "details-sp-pinjia-col-1"
    }, [_c('p', {
      staticClass: "pinjia-ms"
    }, [_vm._v("\n                     \t       描述相符度："), _c('span', {
      class: 'sp-pj-star star' + credit.creditPoint
    }), _vm._v("\n                        \t发货速度："), _c('span', {
      class: 'sp-pj-star star' + credit.speedPoint
    }), _vm._v("\n                        \t服务态度："), _c('span', {
      class: 'sp-pj-star star' + credit.attitudePoint
    })]), _vm._v(" "), _c('p', {
      staticClass: "pinjia-con"
    }, [_vm._v(_vm._s(credit.content))]), _vm._v(" "), (credit.creditImgs != undefined && credit.creditImgs.length > 0) ? _c('div', {
      staticClass: "pinjia-img"
    }, _vm._l((credit.creditImgs), function(gI, imgIdx) {
      return _c('img', {
        attrs: {
          "alt": "",
          "bimg": gI,
          "src": gI,
          "width": "48",
          "height": "48"
        },
        on: {
          "click": function($event) {
            _vm.showImg(creditIdx, gI)
          }
        }
      })
    })) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "pinjia_scale_img",
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "id": creditIdx + '_div'
      }
    }, [_c('img', {
      attrs: {
        "id": creditIdx
      },
      on: {
        "click": function($event) {
          _vm.hideImg(creditIdx)
        }
      }
    })])]), _vm._v(" "), (credit.ext2 != undefined && credit.ext2 != '') ? _c('div', {
      staticClass: "details-sp-pinjia-col-1"
    }, [_c('p', {
      staticClass: "pinjia-con"
    }, [_c('span', {
      staticStyle: {
        "color": "#999"
      }
    }, [_vm._v("[追加评论]")]), _c('br'), _vm._v(_vm._s(credit.ext2))]), _vm._v(" "), (credit.appendImgs != undefined && credit.appendImgs.length > 0) ? _c('div', {
      staticClass: "pinjia-img"
    }, _vm._l((credit.appendImgs), function(gI_append, imgIdx) {
      return _c('img', {
        attrs: {
          "alt": "",
          "bimg": gI_append,
          "src": gI_append,
          "width": "48",
          "height": "48"
        },
        on: {
          "click": function($event) {
            _vm.showAppendImg(creditIdx, gI_append)
          }
        }
      })
    })) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "pinjia_scale_img",
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "id": creditIdx + '_append_div'
      }
    }, [_c('img', {
      attrs: {
        "id": creditIdx + '_append'
      },
      on: {
        "click": function($event) {
          _vm.hideAppendImg(creditIdx)
        }
      }
    })])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "details-sp-pinjia-col-2"
    }, [_c('p', {
      staticClass: "pj-user"
    }, [_c('span', [_vm._v("评价人：")]), _vm._v(" " + _vm._s(credit.buyerName) + "（匿名）")]), _vm._v(" "), _c('p', {
      staticClass: "pj-time"
    }, [_vm._v(_vm._s(credit.dataStr) + " ")])])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "top",
    on: {
      "click": function($event) {
        _vm.scrollToTop()
      }
    }
  }, [_vm._m(17)])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('footermenu'), _vm._v(" "), _c('footercopyright')], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "item"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("首页")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jqzoom-ico"
  }, [_c('span', [_c('img', {
    attrs: {
      "src": require("../../../static/images/zoom.png"),
      "width": "26",
      "height": "26"
    }
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('dt', [_vm._v("订购说明")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('dt', [_vm._v("打样要求")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("配件名称")]), _c('td', [_vm._v("调整说明")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('dt', [_vm._v("上传图片")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('dt', [_vm._v("品质等级:")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('dt', [_vm._v("附件")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('dt', [_vm._v("期望交期")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "target": "_self"
    }
  }, [_c('i', {
    attrs: {
      "title": "分享到微信"
    }
  }), _c('span'), _vm._v("微信")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "target": "_self"
    }
  }, [_c('i', {
    attrs: {
      "title": "分享到QQ空间"
    }
  }), _c('span'), _vm._v("QQ空间")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "target": "_self"
    }
  }, [_c('i', {
    attrs: {
      "title": "分享到新浪微博"
    }
  }), _c('span'), _vm._v("微博")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "target": "_self"
    }
  }, [_c('i', {
    attrs: {
      "title": "商品二维码"
    }
  }), _c('span'), _vm._v("二维码")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "js_qrcode_img js_share_qrcode",
    attrs: {
      "title": ""
    }
  }, [_c('canvas', {
    attrs: {
      "id": "canvas",
      "width": "120",
      "height": "120"
    }
  }), _c('img', {
    attrs: {
      "src": ""
    }
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "js_qrcode_img js_share_qrcode",
    attrs: {
      "title": ""
    }
  }, [_c('canvas', {
    attrs: {
      "id": "picCanvas",
      "width": "220",
      "height": "220"
    }
  }), _c('img', {
    attrs: {
      "src": ""
    }
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hd"
  }, [_c('ul', [_c('li', {
    staticClass: "hover"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v("商品描述")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v("商品评价")])])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "ico-l"
  }), _vm._v("产品详情")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', [_c('span', [_vm._v("TOP")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36686b1e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/goods/goodsDetail.vue
// module id = Tgkl
// module chunks = 1